import { PropsWithChildren } from "react";
import Header from "../Header/Header";

interface PageContainerProps {
  title: string;
  subTitle?: string;
}

const PageContainer = ({
  title,
  subTitle,
  children,
}: PropsWithChildren<PageContainerProps>) => {
  return (
    <>
      <Header />
      <div className="py-6 bg-white">
        <header>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 pb-4">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              {title}
            </h1>
            {subTitle && (
              <p className="mt-1 text-sm text-gray-600">
                {subTitle}
              </p>
            )}
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </>
  );
};

export default PageContainer;
